  // help js
  var roleTabsContainer = document.querySelectorAll('.chatbowl-manual-nav-panel__content--nav')
  var roleTabs = document.querySelectorAll('.chatbowl-manual-nav-panel__content--nav--item')
  var guideContentSectionAll = document.querySelectorAll('.guide-content-section')

  // ガイドのタブを変更するメソッド
  for(var i = 0; i < roleTabsContainer.length; i++){
    roleTabsContainer[i].addEventListener('click', (e) => {
        var roleTab = e.target.closest('.chatbowl-manual-nav-panel__content--nav--item')
        if (!roleTab) return
        for(var i = 0; i < roleTabs.length ; i++){
            roleTabs[i].classList.remove('active')
        }
        var currentActiveTab = document.querySelectorAll(`.chatbowl-manual-nav-panel__content--nav--item--${roleTab.dataset.tabId}`)
        for(var i = 0; i < currentActiveTab.length ; i++){
            currentActiveTab[i].classList.add('active')
        }

        for(var i = 0; i < guideContentSectionAll.length ; i++){
            guideContentSectionAll[i].classList.remove('active')
        }
        var currentContent = document.querySelector(`.guide-content-section--${roleTab.dataset.tabId}`)
        currentContent.classList.add('active')
        if (roleTab.dataset.isBottom) {
            currentContent.scrollIntoView({
                behavior: 'smooth'
            })
        }

    })
  }
  